import type { ClockStampType } from '../../models/clock.model';

export const TIMETRACKING_CLOCK_PORT = 'TIMETRACKING_CLOCK_PORT' as const;

export interface TerminalClockProvenance {
  terminalId: string;
  receiptId: string;
  providerKey: string;
  profileVersion: string;
}

export interface ClockTxInput {
  personId: string;
  actingPersonId: string | null;
  at: Date;
  sourceId: string;
  provenance: TerminalClockProvenance;
}

export type ClockQuarantineReason =
  | 'feature-disabled'
  | 'day-locked'
  | 'already-open'
  | 'no-open-stamp'
  | 'too-soon'
  | 'chronology-conflict'
  | 'overlap'
  | 'future-instant'
  | 'blocked-window'
  | 'person-deleted';

export type ClockReminderIntent = { kind: 'schedule' } | { kind: 'cancel'; jobId: string } | { kind: 'none' };

export type ClockTxOutcome =
  | { kind: 'applied'; bookingId: string; reminder: ClockReminderIntent }
  | { kind: 'pending-pair' }
  | { kind: 'quarantined'; reason: ClockQuarantineReason; bookingDate?: string };

export type ClockStampOutcome = ClockTxOutcome & { direction: ClockStampType };

/** Callers await `FeatureAccessService.ensureCurrentTenant()` before opening the tx for `clock*InTx` / `stampInTx`, and call `applyReminder` after commit. */
export interface TimetrackingClockPort {
  lockPerson(personId: string, tx: unknown): Promise<void>;
  clockInInTx(tx: unknown, input: ClockTxInput): Promise<ClockTxOutcome>;
  clockOutInTx(tx: unknown, input: ClockTxInput): Promise<ClockTxOutcome>;
  /** Direction-less terminal scan: the person's open stamp decides — none ⇒ clock in, open ⇒ clock out. */
  stampInTx(tx: unknown, input: ClockTxInput): Promise<ClockStampOutcome>;
  applyReminder(personId: string, bookingId: string, reminder: ClockReminderIntent): Promise<void>;
}
